const common: Record<string, string> = {
  // Nav
  "nav.home": "Início",
  "nav.categories": "Categorias",
  "nav.blog": "Blog",
  "nav.about": "Sobre",
  "nav.login": "Entrar",
  "nav.guide": "Guia de Compras",
  "nav.hoobuysheet": "hoobuy sheet",
  "nav.buynow": "buy it now",

  // Hero
  "hero.line1": "Hoobuyspreadsheet",
  "hero.line2": "2026: O Guia",
  "hero.line3": "Mais Completo",
  "hero.cta": "hoobuy sheet",
  "hero.tagline": "A MAIOR COMUNIDADE DE SPREADSHEETS VERIFICADOS DO MUNDO",

  // CTA Section
  "cta.title_line1": "Encontre os melhores",
  "cta.title_line2": "preços. Compre com",
  "cta.title_line3": "segurança. Economize",
  "cta.title_line4": "tempo.",
  "cta.button": "buy it now",

  // Categories
  "categories.tag": "Navegar",
  "categories.title": "Todas as Categorias",
  "categories.subtitle": "Hoobuy",
  "categories.desc": "Explore nossa coleção completa de produtos verificados e links confiáveis para suas compras.",

  // Category names
  "cat.shoes": "Shoes",
  "cat.shoes.desc": "Tênis e calçados verificados",
  "cat.hoodies": "Hoodies/Sweaters",
  "cat.hoodies.desc": "Moletons e suéteres autênticos",
  "cat.tshirts": "T-Shirts",
  "cat.tshirts.desc": "Camisetas originais garantidas",
  "cat.jackets": "Jackets",
  "cat.jackets.desc": "Jaquetas e casacos premium",
  "cat.pants": "Pants/Shorts",
  "cat.pants.desc": "Calças e bermudas selecionadas",
  "cat.headwear": "Headwear",
  "cat.headwear.desc": "Bonés e acessórios de cabeça",
  "cat.sets": "Sets",
  "cat.sets.desc": "Conjuntos completos coordenados",
  "cat.underwear": "Underwear/Underpants",
  "cat.underwear.desc": "Roupas íntimas originais",
  "cat.jersey": "Jersey",
  "cat.jersey.desc": "Camisas esportivas oficiais",
  "cat.accessories": "Accessories",
  "cat.accessories.desc": "Acessórios exclusivos verificados",
  "cat.bags": "Bags",
  "cat.bags.desc": "Bolsas e mochilas autênticas",
  "cat.belts": "Belts",
  "cat.belts.desc": "Cintos originais selecionados",
  "cat.perfumes": "Perfumes",
  "cat.perfumes.desc": "Perfumes e fragrâncias importadas",
  "cat.other": "Other Stuff",
  "cat.other.desc": "Itens diversos e novidades",

  // About / SEO
  "about.tag": "O que é",
  "about.title1": "O que é",
  "about.title2": "Hoobuyspreadsheet?",
  "about.text": "O Hoobuyspreadsheet é um sistema organizado de listas e links que permite encontrar produtos, fornecedores e ofertas dentro da plataforma Hoobuy de forma rápida, segura e eficiente. Em vez de pesquisar manualmente, você acessa planilhas atualizadas com produtos verificados, links confiáveis, comparações de preços e recomendações da comunidade. Criamos o Hoobuy Forum para centralizar todos os Hoobuyspreadsheet atualizados em um único lugar confiável.",
  "about.link": "Guia Completo →",
  "about.stat1": "14K+",
  "about.stat1.desc": "Links Verificados",
  "about.stat2": "2026",
  "about.stat2.desc": "Atualização Diária",

  // Blog
  "blog.title1": "Últimos",
  "blog.title2": "Artigos SEO",
  "blog.article1.title": "Como Usar Hoobuy Sheet Sem Erros",
  "blog.article1.desc": "Guia completo para iniciantes aproveitarem ao máximo as planilhas Hoobuy com segurança.",
  "blog.article2.title": "Hoobuyspreadsheet vs Alternativas",
  "blog.article2.desc": "Comparação detalhada entre as principais opções de spreadsheets disponíveis no mercado.",
  "blog.article3.title": "10 Dicas Para Comprar Melhor",
  "blog.article3.desc": "Estratégias comprovadas para economizar e evitar golpes nas suas compras online.",
  "blog.article4.title": "Guia Definitivo de Tênis no Hoobuy",
  "blog.article4.desc": "Descubra os melhores fornecedores de tênis e como identificar réplicas de alta qualidade.",
  "blog.article5.title": "Como Identificar Links Falsos",
  "blog.article5.desc": "Aprenda a reconhecer planilhas fraudulentas e proteger seu dinheiro nas compras.",
  "blog.article6.title": "Top 10 Fornecedores Confiáveis",
  "blog.article6.desc": "Lista atualizada com os fornecedores mais bem avaliados pela comunidade Hoobuy.",
  "blog.article7.title": "Erros Comuns de Iniciantes",
  "blog.article7.desc": "Os 7 erros que todo iniciante comete e como evitá-los desde o primeiro dia.",
  "blog.article8.title": "Guia de Tamanhos e Medidas",
  "blog.article8.desc": "Tabela completa de conversão de tamanhos para comprar roupas sem erro.",
  "blog.article9.title": "Economize Até 70% nas Compras",
  "blog.article9.desc": "Técnicas avançadas para encontrar os melhores preços usando o Hoobuyspreadsheet.",
  "blog.article10.title": "Jersey e Camisas Esportivas",
  "blog.article10.desc": "Onde encontrar as melhores camisas de time e como verificar a autenticidade.",
  "blog.article11.title": "Acessórios Que Valem a Pena",
  "blog.article11.desc": "Guia dos acessórios mais procurados: bolsas, cintos, óculos e perfumes.",
  "blog.article12.title": "Tendências 2026 no Hoobuy",
  "blog.article12.desc": "O que está bombando este ano e quais categorias estão em alta na comunidade.",
  "blog.readmore": "Ler artigo →",

  // Testimonials
  "testimonials.title": "Depoimentos da Comunidade",
  "testimonials.rating": "4.9",
  "testimonials.quote": "O Hoobuy Forum mudou completamente a forma como faço minhas compras. As planilhas são atualizadas diariamente e os links são sempre confiáveis. Recomendo para todos que querem comprar com segurança e economia.",
  "testimonials.author": "Maria Silva",
  "testimonials.role": "Compradora verificada • Membro desde 2025",

  // Footer
  "footer.newsletter_title1": "Fique por dentro",
  "footer.newsletter_title2": "das novidades",
  "footer.newsletter_desc": "Receba as planilhas mais recentes e alertas de segurança diretamente no seu email.",
  "footer.newsletter_label": "Receba atualizações",
  "footer.newsletter_placeholder": "seu@email.com",
  "footer.newsletter_button": "Inscrever",
  "footer.quick_links": "Links Rápidos",
  "footer.categories_title": "Categorias",
  "footer.legal": "Termos e Contato",
  "footer.terms": "Termos de Uso",
  "footer.privacy": "Privacidade",
  "footer.contact": "Contato",
  "footer.copyright": "© 2026 Hoobuy Forum. Todos os direitos reservados.",

  // Article Page
  "article.back": "← Voltar ao Hub",
  "article.tag": "Guia SEO",
  "article.title1": "Hoobuy Sheet",
  "article.title2": "O Segredo Revelado",
  "article.meta.views": "Visualizações",
  "article.meta.updated": "Atualizado",

  // Shopping Guide Page
  "guide.title": "Guia de Compras",
  "guide.subtitle": "Hoobuy 2026",
  "guide.desc": "Tudo o que você precisa saber para comprar com segurança e inteligência na plataforma Hoobuy.",
  "guide.section1.title": "Primeiros Passos",
  "guide.section1.desc": "Comece aqui se você é novo na plataforma Hoobuy.",
  "guide.section2.title": "Segurança",
  "guide.section2.desc": "Proteja-se contra golpes e links fraudulentos.",
  "guide.section3.title": "Categorias",
  "guide.section3.desc": "Explore todas as categorias de produtos disponíveis.",
  "guide.section4.title": "Avançado",
  "guide.section4.desc": "Dicas e truques para compradores experientes.",
};

export default common;